// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"757": "832702cbfb1bf93f","804": "0aae2cfe6d4aa56d",}[chunkId] + ".js"
}